import React, { Fragment, Component } from 'react';
import { NavLink as RRNavLink } from 'react-router-dom';
import { NavLink, DropdownMenu, UncontrolledDropdown, DropdownToggle } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/Configurator';
import Helper from '../../Helper';
import locale from '../../Locale';

interface IProps {
	configuration: any;
	setRemarksCount: (remarksType: string, count: number) => void;
}

class CustomerEditMenu extends Component<IProps> {
	componentDidMount() {
		this.loadRemarksCounts();
	}

	componentDidUpdate(prevProps: IProps) {
		if (prevProps.configuration?.documentConfigurationId !== this.props.configuration?.documentConfigurationId) {
			this.loadRemarksCounts();
		}
	}

	loadRemarksCounts() {
		const documentConfigurationId = this.props.configuration?.documentConfigurationId;
		if (!documentConfigurationId) {
			return;
		}

		Helper.getData<any>('/document/configuration/' + documentConfigurationId + '/notes?type=0').then((data) => {
			this.props.setRemarksCount('sales', data?.length || 0);
		});
		Helper.getData<any>('/document/configuration/' + documentConfigurationId + '/notes?type=1').then((data) => {
			this.props.setRemarksCount('installer', data?.length || 0);
		});
	}

	getMenuTitle(link: any) {
		const count =
			link.remarksType === 'sales'
				? this.props.configuration?.salesRemarksCount
				: link.remarksType === 'installer'
					? this.props.configuration?.installerRemarksCount
					: 0;

		if (count > 0) {
			return (
				<>
					{link.title}
					<span className='admin-menu-count'> ({count})</span>
				</>
			);
		}
		return link.title;
	}

	renderNavigation(links: any[], navLinkClass: string) {
		return links.map((link: any) => {
			return (
				<Fragment key={link.id}>
					<div className='mr-auto pt-1 mb-2 navbar-wrapper admin-menu'>
						<NavLink tag={RRNavLink} className={navLinkClass} to={link.url}>
							{this.getMenuTitle(link)}
						</NavLink>
					</div>
				</Fragment>
			);
		});
	}

	render() {
		const baseName = process.env.REACT_APP_ROOT_PATH;
		const navLinkClass = 'text-uppercase navbar-brand admin-menu-item';
		const pathName = window.location.pathname.toLowerCase().replace(/\/$/, '');

		const adminDocument = [
			{
				id: 1,
				url: baseName + '/admin/document/configurations',
				title: locale.adminMenuConfigurations,
			},
			{
				id: 2,
				url: baseName + '/admin/document/document',
				title: locale.adminMenuDocument,
			},
			{
				id: 3,
				url: baseName + '/admin/document/terms',
				title: locale.termsPage,
			},
			{
				id: 4,
				url: baseName + '/admin/document/contact',
				title: locale.contact,
			},
			{
				id: 5,
				url: baseName + '/admin/document/print',
				title: locale.adminMenuPrintDocument,
			},
			{
				id: 6,
				url: baseName + '/admin/document/history',
				title: locale.adminMenuHistory,
			},
		];

		const installerDocument = [
			{
				id: 1,
				url: baseName + '/admin/document/configurations',
				title: locale.adminMenuConfigurations,
			},
			{
				id: 2,
				url: baseName + '/admin/document/document',
				title: locale.adminMenuDocument,
			},
		];

		const adminConfiguration = [
			{
				id: 1,
				url: baseName + '/admin/configuration/calculation',
				title: locale.adminMenuCalculation,
			},
			{
				id: 2,
				url: baseName + '/admin/configuration/position',
				title: locale.adminMenuPosition,
			},
			{
				id: 3,
				url: baseName + '/admin/configuration/costs',
				title: locale.adminMenuDiscountsCosts,
			},
			{
				id: 5,
				url: baseName + '/admin/configuration/images',
				title: locale.adminMenuTechnicalDocumentation,
			},
			{
				id: 6,
				url: baseName + '/admin/configuration/remarks',
				title: locale.adminMenuSalesRemarks,
				remarksType: 'sales',
			},
			{
				id: 7,
				url: baseName + '/admin/configuration/monter',
				title: locale.adminMenuInstallerRemarks,
				remarksType: 'installer',
			},
		];

		const installerConfiguration = [
			{
				id: 1,
				url: baseName + '/admin/configuration/calculation',
				title: locale.adminMenuCalculation,
			},
			{
				id: 4,
				url: baseName + '/admin/configuration/images',
				title: locale.adminMenuTechnicalDocumentation,
			},
			{
				id: 6,
				url: baseName + '/admin/configuration/monter',
				title: locale.adminMenuInstallerRemarks,
				remarksType: 'installer',
			},
		];

		const adminDocumentNavigation = this.renderNavigation(adminDocument, navLinkClass);
		const installerDocumentNavigation = this.renderNavigation(installerDocument, navLinkClass);
		const adminConfigurationNavigation = this.renderNavigation(adminConfiguration, navLinkClass);
		const installerConfigurationNavigation = this.renderNavigation(installerConfiguration, navLinkClass);

		const getActiveTitle = (links: any[]) => {
			const activeLink = links.find((e) => e.url.toLowerCase() === pathName);
			return activeLink ? this.getMenuTitle(activeLink) : '';
		};

		if (window.location.pathname.toLowerCase().indexOf('/admin/configuration') >= 0) {
			if (Helper.userInstaller()) {
				return (
					<Fragment>
						<div className='nav-form'>{installerConfigurationNavigation}</div>
						<UncontrolledDropdown className='nav-dropdown'>
							<DropdownToggle caret color='selector' className='dropdown-selector' style={{ width: '100%' }}>
								{getActiveTitle(installerConfiguration)}
								&nbsp;
							</DropdownToggle>
							<DropdownMenu className='nav-items'>{installerConfigurationNavigation}</DropdownMenu>
						</UncontrolledDropdown>
					</Fragment>
				);
			} else if (Helper.userAdmin()) {
				return (
					<Fragment>
						<div className='nav-form'>{adminConfigurationNavigation}</div>
						<UncontrolledDropdown className='nav-dropdown'>
							<DropdownToggle caret color='selector' className='dropdown-selector' style={{ width: '100%' }}>
								{getActiveTitle(adminConfiguration)}
								&nbsp;
							</DropdownToggle>
							<DropdownMenu className='nav-items'>{adminConfigurationNavigation}</DropdownMenu>
						</UncontrolledDropdown>
					</Fragment>
				);
			}
		} else {
			if (Helper.userInstaller()) {
				return (
					<Fragment>
						<div className='nav-form'>{installerDocumentNavigation}</div>
						<UncontrolledDropdown className='nav-dropdown'>
							<DropdownToggle caret color='selector' className='dropdown-selector' style={{ width: '100%' }}>
								{getActiveTitle(installerDocument)}
								&nbsp;
							</DropdownToggle>
							<DropdownMenu className='nav-items'>{installerDocumentNavigation}</DropdownMenu>
						</UncontrolledDropdown>
					</Fragment>
				);
			} else if (Helper.userAdmin()) {
				return (
					<Fragment>
						<div className='nav-form'>{adminDocumentNavigation}</div>
						<UncontrolledDropdown className='nav-dropdown'>
							<DropdownToggle caret color='selector' className='dropdown-selector' style={{ width: '100%' }}>
								{getActiveTitle(adminDocument)}
								&nbsp;
							</DropdownToggle>
							<DropdownMenu className='nav-items'>{adminDocumentNavigation}</DropdownMenu>
						</UncontrolledDropdown>
					</Fragment>
				);
			}
		}
		return null;
	}
}

export default connect(
	(state: any) => ({ configuration: state.configurator.configuration }),
	(dispatch) => bindActionCreators(actionCreators, dispatch),
)(CustomerEditMenu);
